import { Button, Form, Input, Spin } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import appConfig from "@/config/appConfig";
import { useSelector } from "react-redux";
import { api } from "@/api";
import { flare } from "@flareapp/js";

const onFinishFailed = (values) => {
  // eslint-disable-next-line no-console
  console.log("error", values);
};

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { businessUrl = "" } = useParams();

  const { userDetails } = useSelector((state) => state.user || {});
  const business = userDetails?.business?.[0] || {};

  const [loginData, setLoginData] = useState({});
  const [loading, setLoading] = useState(false);

  const getLoginData = async () => {
    setLoading(true);
    try {
      const data = await api.get(`/business/user-login-data`, {
        params: {
          businessUrl,
          unique: true,
        },
      });
      setLoginData(data?.data);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("Login data", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (businessUrl) {
      getLoginData();
    }
  }, [businessUrl]);

  useEffect(() => {
    document.title = `${appConfig.name} - Forgot Password`;
  }, []);

  const onFinish = async (values) => {
    try {
      await axios.post(
        `/user/forgot-password`,
        { email: values.email?.toLocaleLowerCase() },
        { withCredentials: true },
      );
      await Swal.fire({
        title: "Done!",
        text: "A Password Reset Link has been Sent to This Email Address",
        icon: "success",
        timer: 2000,
        confirmButtonText: "OK",
      });
      if (business?.businessUrl) {
        navigate("/" + business?.businessUrl);
      } else {
        navigate("/");
      }
    } catch {
      await Swal.fire({
        title: "",
        text: "Email Not Found",
        icon: "error",
        timer: 2000,
        confirmButtonText: "OK",
      });
    }
  };
  const background = loginData?.bgImage || "/img/bg.jpg";
  const logo = loginData?.logo || "/img/logo.png";

  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
        {" "}
        <Spin spinning={loading} />{" "}
      </div>
    );
  }
  return (
    <div>
      <div
        className="az-content-wrapper p-0"
        style={{ backgroundImage: `url(${background})`, backgroundAttachment: "fixed" }}
      >
        <div>
          <div className="sigIn_form">
            <div className="sigIn_card">
              <div className="signIn_inner">
                <h1 className="az-logo text-center" style={{ maxWidth: "230px", margin: "0 auto 40px" }}>
                  <img src={logo} style={{ maxHeight: "60px" }} alt="logo" className="img-fluid" />
                </h1>
                <div className="az-signin-header">
                  <h5 className="fw-bold">Forgot Password?</h5>

                  <p style={{ fontSize: "13px", marginTop: "15px" }}>
                    Please contact support at{" "}
                    <a href="mailto:tech@reneontech.com">
                      <b>tech@reneontech.com </b>
                    </a>
                    to request for a password reset if you have not registered your account with an email or Login ID.
                  </p>

                  <Form
                    name="signInFrom"
                    layout="vertical"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    form={form}
                    validateTrigger="onFinish"
                  >
                    <Form.Item
                      label="Email/Login ID"
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: "Input Your Email/Login ID",
                        },
                      ]}
                    >
                      <Input placeholder="Input Your Email/Login ID" />
                    </Form.Item>

                    <div className="mb-3">
                      <Button type="primary" block htmlType="submit">
                        Submit
                      </Button>
                    </div>
                  </Form>
                  <div className="d-flex align-items-center my-4">
                    <hr className="w-100 border-dark-subtle" />
                    <div className="px-3 fw-semibold">or</div>
                    <hr className="w-100 border-dark-subtle" />
                  </div>
                  <Link to={"/" + businessUrl} className="d-block my-3">
                    <Button block>Back To Login</Button>
                  </Link>
                </div>
                <div className="az-signin-footer text-center mt-2">
                  <p>Version {appConfig.version}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
